module.exports = __webpack_public_path__ + "img/photo_brushes.87ecf67e.png";